import HttpClientRequest from "../api/client-request";
import { Credentials, HttpResponse, SignupCredentials } from "../types";

let logoutFunction: (() => void) | null = null;

export const setLogoutFunction = (fn: () => void) => {
    logoutFunction = fn;
}

export const getLogoutFunction = () => logoutFunction;


export default class AuthService {

    static async register(signupPayload: SignupCredentials, requestId?: string): Promise<HttpResponse> {
        try {
            
            const response = await HttpClientRequest.doPostRequest('users/customer/register', signupPayload, {
                'Content-Type': 'application/json'
            }, requestId);

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error fetching products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }
    
    static async login(signinpPayload: Credentials, requestId?: string): Promise<HttpResponse> {
        try {
            
            const response = await HttpClientRequest.doPostRequest('/users/customer/login', signinpPayload, {
                headers: {
                  'Content-Type': 'application/json',
                }
            });

            return response;

        } catch (error) {
            requestId && HttpClientRequest.cancelRequest(requestId);
            console.error("Error logging in products:", error);
            return {
                status: 503,
                data: [],
                message: (error as Error).message,
                isCanceled: true,
            };
        }
    }


}